import { useMutation } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";

import { BANK_STATEMENTS_SUBMIT_API } from "../../components/constants";

export interface StatementUploadsSubmission {
  object_keys: string[];
  group: string;
}

export const useBankStatementSubmitMutation = (customerDomain: string) => {
  const client = useAxios();
  const mutationUrl = BANK_STATEMENTS_SUBMIT_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: StatementUploadsSubmission) => {
      return client.post(mutationUrl, data);
    },
  });
};
